import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_WEIGHT_METER_URL} from '../../connection.data';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { WeightMeter} from '../_models/weight-meter.model';

@Injectable()
export class WeightMeterService{
    constructor(private http: HttpClient){

    }

    getAll():Observable<WeightMeter[]>{
        const url = `${API_WEIGHT_METER_URL}/all`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getPage(queryParams: QueryParamsModel):Observable<QueryResultsModel>{
        const url = `${API_WEIGHT_METER_URL}/page`;
        return this.http.post<QueryResultsModel>(url, queryParams)
    }

    add(weightMeter:WeightMeter):Observable<number>{
        return this.http.post<any>(API_WEIGHT_METER_URL, weightMeter).pipe(
            map((response)=> response.id)
        );
    }

    edit(weightMeter:WeightMeter):Observable<string>{
        // console.log("edit input: "+JSON.stringify(weightMeter));
        return this.http.put<any>(`${API_WEIGHT_METER_URL}/${weightMeter.id}`, weightMeter).pipe(
            map((response)=>response.status)
        );
    }

    delete(weightMeter:WeightMeter):Observable<string>{
        return this.http.delete<any>(`${API_WEIGHT_METER_URL}/${weightMeter.id}`).pipe(
            map((response)=>response.status)
        );
    }

    startingAtDate(st: Date){
        const url = `${API_WEIGHT_METER_URL}/period?st=${encodeURIComponent(st.toLocaleString('sv').replace(' ', 'T'))}`;
        // console.log("url: "+url);
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getPeriod(st: Date, et:Date):Observable<any[]>{
        const url = `${API_WEIGHT_METER_URL}/period?st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        console.log("url: "+url);
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getTotalSilePeriod(sile_id:number, st: Date, et:Date):Observable<number>{
        const url = `${API_WEIGHT_METER_URL}/sile/period/total?sile_id=${sile_id}&st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        console.log("url: "+url);
        return this.http.get<{rows: number, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getShiftTotal():Observable<number>{
        const url = `${API_WEIGHT_METER_URL}/shift/current/total`;
        console.log("url: "+url);
        return this.http.get<{total: number, status: string}>(url).pipe(
            map((response)=>{
                return response.total;
            })
        )
    }

    getYearTotal():Observable<number>{
        const url = `${API_WEIGHT_METER_URL}/year/current/total`;
        console.log("url: "+url);
        return this.http.get<{total: number, status: string}>(url).pipe(
            map((response)=>{
                return response.total;
            })
        )
    }

    getById(id:number){
        const url = `${API_WEIGHT_METER_URL}/${id}`;
        // console.log("url: "+url);
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows[0];
            })
        )
    }

    sendDataToSap(date: Date, userId:number):Observable<boolean>{
        const url = `${API_WEIGHT_METER_URL}/export/sap`;
        // console.log("url: "+url);
        return this.http.post<{status: number}>(url, {starting_date: formatDate(date), user_id: userId}).pipe(
            map((response)=>{
                return response.status==1;
            })
        )
    }
}

function formatDate(date:Date){
    const year = date.getFullYear();
    const month = numberTo2DigitsString(date.getMonth() +1);
    const day = numberTo2DigitsString(date.getDate());
    const hours = numberTo2DigitsString(date.getHours());
    const minutes = numberTo2DigitsString(date.getMinutes());
    const seconds = numberTo2DigitsString(date.getSeconds());
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

function numberTo2DigitsString(number){
    return `${number<10?0:''}${number}`;
}